import { render, staticRenderFns } from "./TransactionModal.vue?vue&type=template&id=8011275a"
import script from "./TransactionModal.vue?vue&type=script&lang=js"
export * from "./TransactionModal.vue?vue&type=script&lang=js"
import style0 from "./TransactionModal.vue?vue&type=style&index=0&id=8011275a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports